<template>
  <el-dialog
      title="Đồng bộ album cũ sang album mới"
      :visible.sync="dialogVisible"
      width="780px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="5vh"
  >
    <section v-loading="isLoading">
      <div class="migration-card">
        <div class="card-sub-title">
          <i class="el-icon-s-operation"></i> Thông tin đồng bộ
        </div>

        <el-form
            ref="migrateForm"
            :model="form"
            :rules="activeRules"
            label-position="top"
            size="small"
        >
          <el-form-item label="Phạm vi đồng bộ" prop="scope">
            <el-radio-group v-model="form.scope" @change="handleScopeChange">
              <el-radio label="school">Một trường</el-radio>
              <el-radio label="all">Tất cả trường</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="form.scope === 'school'" label="Trường" prop="schoolId">
            <el-select
                v-model="form.schoolId"
                placeholder="Chọn trường"
                style="width: 100%"
                filterable
            >
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.id + ' - ' + item.schoolName"
              />
            </el-select>
          </el-form-item>

          <div v-else class="all-school-warning">
            <i class="el-icon-warning-outline"></i>
            <span>Hệ thống sẽ đồng bộ album của tất cả trường trong khoảng ngày đã chọn.</span>
          </div>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="Từ ngày" prop="fromDate">
                <el-date-picker
                    v-model="form.fromDate"
                    type="date"
                    placeholder="Chọn ngày bắt đầu"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Đến ngày" prop="toDate">
                <el-date-picker
                    v-model="form.toDate"
                    type="date"
                    placeholder="Chọn ngày kết thúc"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="warning-note">
          <i class="el-icon-warning-outline"></i>
          <div>
            <div>Album đã đồng bộ thành công sẽ được bỏ qua, không ghi đè.</div>
            <div>Album và ảnh đã xoá mềm sẽ được bỏ qua; quan hệ học sinh xoá mềm cũng không được chuyển.</div>
            <div v-if="form.scope === 'all'">Album và ảnh chuyển thành công sẽ được đánh dấu để không lấy lại ở lần chạy sau.</div>
            <div>Ảnh dùng lại metadata và đường dẫn storage cũ, không copy lại file.</div>
          </div>
        </div>
      </div>

      <div class="migration-card" v-if="result !== null">
        <div class="card-sub-title">
          <i class="el-icon-data-analysis"></i> Kết quả đồng bộ
        </div>

        <div class="result-summary">
          <div class="summary-box total">
            <span class="num">{{ result.totalAlbums }}</span>
            <span class="lbl">Tổng album</span>
          </div>
          <div class="summary-box success">
            <span class="num">{{ result.importedAlbums }}</span>
            <span class="lbl">Đã đồng bộ ✅</span>
          </div>
          <div class="summary-box skipped">
            <span class="num">{{ result.skippedAlbums }}</span>
            <span class="lbl">Bỏ qua ⏭️</span>
          </div>
          <div class="summary-box failed">
            <span class="num">{{ result.failedAlbums }}</span>
            <span class="lbl">Lỗi ❌</span>
          </div>
        </div>

        <div class="result-metrics">
          <div><span>Ảnh đã đồng bộ</span><strong>{{ result.importedPictures || 0 }}</strong></div>
          <div><span>Liên kết học sinh đã đồng bộ</span><strong>{{ result.importedRelations || 0 }}</strong></div>
        </div>

        <div class="result-legend">
          <div class="legend-title">
            <i class="el-icon-info"></i>
            <span>Chú thích</span>
          </div>
          <div class="legend-item">
            <strong>Đã đồng bộ:</strong> số album đã được đồng bộ thành công.
          </div>
          <div class="legend-item">
            <strong>Bỏ qua:</strong> album đã tồn tại hoặc đã được đồng bộ trước đó.
          </div>
          <div class="legend-item">
            <strong>Lỗi:</strong> album không thể đồng bộ, xem chi tiết bên dưới để xử lý lại.
          </div>
        </div>

        <el-collapse v-if="result.details && result.details.length" class="detail-collapse">
          <el-collapse-item name="details">
            <template slot="title">
              <i class="el-icon-tickets"></i>&nbsp; Chi tiết từng album
            </template>
            <el-table :data="result.details" border stripe max-height="280" class="detail-table">
              <el-table-column prop="sourceAlbumId" label="Id" width="100" align="center" header-align="center" />
              <el-table-column label="Trạng thái" width="115" align="center" header-align="center">
                <template slot-scope="scope">
                  <el-tag :type="statusTagType(scope.row.status)">{{ statusLabel(scope.row.status) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Ảnh" width="92" align="center" header-align="center">
                <template slot-scope="scope">{{ scope.row.importedPictureCount || 0 }} / {{ scope.row.sourcePictureCount || 0 }}</template>
              </el-table-column>
              <el-table-column label="Liên kết HS" width="112" align="center" header-align="center">
                <template slot-scope="scope">{{ scope.row.importedRelationCount || 0 }} / {{ scope.row.sourceRelationCount || 0 }}</template>
              </el-table-column>
              <el-table-column
                  prop="errorMessage"
                  label="Ghi chú"
                  min-width="220"
                  align="left"
                  header-align="center"
                  show-overflow-tooltip
              />
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </section>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog">
        <i class="el-icon-circle-close"/> Đóng
      </el-button>
      <el-button type="primary" size="medium" :loading="isLoading" @click="handleMigrate">
        <i class="el-icon-refresh"/> Đồng bộ
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import AlbumService from "@/modules/album/services/AlbumService";

export default {
  name: "AlbumLegacySyncDialog",
  props: {
    dialogVisible: { type: Boolean, default: false, required: true },
    schoolList: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {
        scope: "school",
        schoolId: null,
        fromDate: null,
        toDate: null,
      },
      result: null,
      isLoading: false,
      schoolRules: {
        schoolId: [{required: true, message: "Vui lòng chọn trường", trigger: "change"}],
        fromDate: [{required: true, message: "Vui lòng chọn ngày bắt đầu", trigger: "change"}],
        toDate: [{required: true, message: "Vui lòng chọn ngày kết thúc", trigger: "change"}],
      },
      allSchoolRules: {
        fromDate: [{required: true, message: "Vui lòng chọn ngày bắt đầu", trigger: "change"}],
        toDate: [{required: true, message: "Vui lòng chọn ngày kết thúc", trigger: "change"}],
      },
    };
  },
  computed: {
    activeRules() {
      return this.form.scope === "all" ? this.allSchoolRules : this.schoolRules;
    },
  },
  methods: {
    handleScopeChange() {
      this.result = null;
      if (this.form.scope === "all") {
        this.form.schoolId = null;
      }
      this.$nextTick(() => this.$refs.migrateForm && this.$refs.migrateForm.clearValidate());
    },
    handleMigrate() {
      this.$refs.migrateForm.validate((valid) => {
        if (!valid) return;
        if (this.form.fromDate > this.form.toDate) {
          this.$message({message: "Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc", type: "error"});
          return;
        }
        const isAllSchools = this.form.scope === "all";
        this.$confirm(
            isAllSchools
                ? "Hệ thống sẽ đồng bộ tất cả trường, lấy tuần tự 100 album mỗi lần. Album và ảnh thành công sẽ được đánh dấu đã chuyển. Bạn có chắc chắn muốn tiếp tục?"
                : "Hệ thống lấy tuần tự 100 album mỗi lần và chỉ gửi batch kế tiếp khi batch trước đã được Tuition xử lý. Bạn có chắc chắn muốn đồng bộ?",
            "Xác nhận đồng bộ",
            {confirmButtonText: "Xác nhận", cancelButtonText: "Huỷ bỏ", type: "warning", closeOnClickModal: false}
        ).then(() => this.executeMigrate()).catch(() => {});
      });
    },
    async executeMigrate() {
      this.isLoading = true;
      this.result = null;
      try {
        const request = {
          startDate: this.form.fromDate,
          endDate: this.form.toDate,
        };
        const response = this.form.scope === "all"
            ? await AlbumService.startAllLegacyAlbumSync(request)
            : await AlbumService.startLegacyAlbumSync({
              ...request,
              schoolId: this.form.schoolId,
            });
        this.result = response.data.data || {
          totalAlbums: 0,
          importedAlbums: 0,
          skippedAlbums: 0,
          failedAlbums: 0,
          importedPictures: 0,
          importedRelations: 0,
          details: [],
        };
        if (this.result.failedAlbums > 0) {
          this.$message({message: "Có album lỗi, vui lòng kiểm tra chi tiết", type: "warning"});
        } else if (this.result.totalAlbums === 0) {
          this.$message({message: "Không tìm thấy album theo bộ lọc", type: "info"});
        } else {
          this.$message({message: "Đồng bộ album thành công", type: "success"});
        }
      } catch (error) {
        const message = error?.response?.data?.message || "Có lỗi xảy ra khi đồng bộ album";
        this.$message({message, type: "error"});
      } finally {
        this.isLoading = false;
      }
    },
    statusLabel(status) {
      return {SUCCESS: "Thành công", SKIPPED: "Bỏ qua", FAILED: "Thất bại"}[status] || status;
    },
    statusTagType(status) {
      return {SUCCESS: "success", SKIPPED: "info", FAILED: "danger"}[status] || "info";
    },
    closeDialog() {
      this.result = null;
      this.form.scope = "school";
      this.form.schoolId = null;
      this.form.fromDate = null;
      this.form.toDate = null;
      this.$refs.migrateForm && this.$refs.migrateForm.resetFields();
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.migration-card {
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #eef2f6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  margin-bottom: 16px;
}

.card-sub-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.warning-note {
  margin-top: 16px;
  padding: 10px 14px;
  background-color: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  font-size: 13px;
  color: #92400e;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.6;

  i { font-size: 16px; color: #d97706; margin-top: 2px; }
}

.all-school-warning {
  margin: -4px 0 16px;
  padding: 10px 14px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #991b1b;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;

  i { margin-top: 2px; font-size: 16px; }
}

.result-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 16px;

  .summary-box {
    padding: 14px 12px;
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 4px;

    &.total { background-color: #f0f9ff; border: 1px solid #bae6fd; .num { color: #0369a1; } }
    &.success { background-color: #f0fdf4; border: 1px solid #bbf7d0; .num { color: #166534; } }
    &.skipped { background-color: #fffbeb; border: 1px solid #fde68a; .num { color: #92400e; } }
    &.failed { background-color: #fef2f2; border: 1px solid #fecaca; .num { color: #991b1b; } }

    .num { font-size: 22px; font-weight: 700; }
    .lbl { font-size: 12px; color: #64748b; }
  }
}

.result-metrics {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;

  div {
    display: flex;
    justify-content: space-between;
    padding: 10px 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    color: #64748b;
    font-size: 13px;
  }

  strong { color: #1e3a8a; font-size: 16px; }
}

.result-legend {
  margin-bottom: 16px;
  padding: 12px 14px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;

  .legend-title {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    color: #334155;
    font-size: 13px;
    font-weight: 600;
    i { color: #2563eb; }
  }

  .legend-item { margin-top: 3px; }
  strong { color: #334155; }
  code { color: #1d4ed8; }
}

.detail-collapse { border-top: 1px solid #ebeef5; }
::v-deep .el-dialog { border-radius: 16px; overflow: hidden; }
::v-deep .el-dialog__header { background: linear-gradient(135deg, #2563eb, #1d4ed8); padding: 18px 24px !important; }
::v-deep .el-dialog__title { color: white !important; font-size: 19px !important; font-weight: 600; }
::v-deep .el-dialog__headerbtn .el-dialog__close { color: white !important; font-size: 22px; }
::v-deep .el-dialog__body { max-height: 74vh; overflow-y: auto; background: #f8fafc; padding: 20px 24px !important; }
::v-deep .el-dialog__footer { background: #f1f5f9; padding: 14px 24px !important; border-top: 1px solid #e2e8f0; }

@media (max-width: 600px) {
  .result-summary { grid-template-columns: repeat(2, 1fr); }
  .result-metrics { grid-template-columns: 1fr; }
}
</style>
